/* export const onPublish = (event, item, ele) => {
    const model = {...event.detail, mla: item}
    console.log(model)
    ele.setState({emailAlert: true, model})
} */

import React from 'react';
import Box from 'grommet/components/Box';
import Button from 'grommet/components/Button';
import Label from 'grommet/components/Label';
import Spinning from 'grommet/components/icons/Spinning';
import Layer from 'grommet/components/Layer';

function generateUUID() { // Public Domain/MIT
    var d = new Date().getTime();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function'){
        d += performance.now(); //use high-precision timer if available
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}

class Publish extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            
            emailAlert: false,
            model: props.model,
            id: ""
             }
    }
     _onChangeEmail(event) {
        this.setState({email: event.target.value})
    }
    _onSubmit(e) {

        //this.setState({emailAlert: false})
        const {model, email, published} = this.state
        const uniqueID = generateUUID()
        //const field1 = "field1"
        //const field2 = "field2"
        //const field3 = "field3"
        if (published) {
            //this.setState({emailAlert: false})
            this.props.onSubmit()
        } else {
           this.setState({spinningFlag: true}) 
            const modelStringify = JSON.stringify(model)
        e.preventDefault();
        const url = `https://script.google.com/macros/s/AKfycbxN_hWJGvJw-g6Ca4klLxSw4AsiyK0o2xzXvS2GkrITOJoRA0uA/exec?email=${email}&model=${modelStringify}&url=${this.props.urlPredict}&id=${uniqueID}`
        /* fetch(url)
            .then(function(response) {
                console.log(response)
            }) */
        
        
        const that = this;
        function postData(url = ``, data = {}) {
                // Default options are marked with *
                  return fetch(url, {
                      method: "GET", // *GET, POST, PUT, DELETE, etc.
                      //mode: "cors", // no-cors, cors, *same-origin
                      //cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
                      //credentials: "same-origin", // include, *same-origin, omit
                      //headers: {
                      //    "Content-Type": "application/json",
                          // "Content-Type": "application/x-www-form-urlencoded",
                      //},
                      //redirect: "follow", // manual, *follow, error
                      //referrer: "no-referrer", // no-referrer, *client
                      data: data, // body data type must match "Content-Type" header
                      //params: data
                  })
                  .then(response => console.log(response)); // parses JSON response into native Javascript objects 
              }
              postData(url, {"field1": "field1"})
              .then(data => {
                  //console.log(that)

                  
                  this.setState({published: true, spinningFlag: false, id: uniqueID})
                  //this.setState({emailAlert: false})
                  
                }) // JSON-string from `response.json()` call
              .catch(error => console.error(error));
        }
        
    }
 
    render() {
        const { published, spinningFlag, id
        } = this.state
        let spinningComponent;

         if (spinningFlag) {
            spinningComponent = <div style={{position: "fixed", backgroundColor: "white", top: "0px", 
            bottom: "0px", right: "0px", left: "0px", opacity: "0.5", paddingTop: "30%",
            zIndex: "500", textAlign: "center"}}>
                <Label>Loading...</Label>
                <Spinning size={"xlarge"}/>
            </div>
        } else {
            spinningComponent = <div></div>
        }
        return (
            <Layer align="center" >
                {spinningComponent}
                <div style={{padding: "25px"}}>
                    <Box direction='row'
                        justify='start'
                        align='left'
                        wrap={true}
                        reverse={false}
                        margin='none'>
                        <Label><b>Share your results! Anywhere Anytime!</b><br/><br/><br/>{published ? "Your view is ready to be shared! Visit" : "Enter your email so you can share this view with your contacts"} </Label>
                        <a target="_blank" href={`https://prophesierstatistics.github.io/custom?id=${id}`}>{published ? `https://prophesierstatistics.github.io/custom?id=${id}` : ""}</a>
                        <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='small'
                            margin='none'
                            style={{width: "80%"}}>
                            {!published ? <input 
                                style={{padding: "0px 24px", width: "400px"}}
                                placeholder={"Email"}
                                onChange={this._onChangeEmail.bind(this)} 
                                /> : null}  <br/><br/>
                        </Box>
                        <Box direction='row'
                            align='center'
                            wrap={true}
                            pad='medium'
                            margin='none'>
                            <Button label={published ? "Done" : "Publish"}
                                type='submit'
                                primary={true}
                                onClick={this._onSubmit.bind(this)} />
                        </Box>                    
                    </Box>
                </div>
            </Layer>
        );
    }
}

export default Publish;



// WEBPACK FOOTER //
// ./src/samples/run/utils/Publish.js